// When the document's ready state changes
document.addEventListener( 'readystatechange', function () {

  // If the new state is 'complete' and the donate form is on the page
  if ( document.readyState === 'complete' && document.querySelector( '#gform_wrapper_4' ) !== null ) {

    // Get the URL parameters
    urlParams = new URLSearchParams();

    // If there's a donate total type variable
    // ( This returns the string 'null' rather than a true null )
    if ( urlParams.get( 'donate-total-type' ) !== 'null' ) {

      // Mobile header
      if ( window.innerWidth < 992 ) {

        // Declare variable for header height
        let headerHeight = 0;

        // Add WP adminbar height
        if ( document.querySelector( '#wpadminbar' ) !== null ) {
          headerHeight += document.querySelector( '#wpadminbar' ).offsetHeight;
        }

        // Add mobile header height
        headerHeight += document.querySelector( '#header-mobile' ).offsetHeight;

        // Scroll the page so form is 15px below the header
        window.scrollTo( 0, document.querySelector( '#gform_wrapper_4' ).getBoundingClientRect().top - headerHeight - 15 );

      }

      // Desktop header
      if ( window.innerWidth >= 992 ) {

        // Scroll the page so form is 15px below the top of the screen
        window.scrollTo( 0, document.querySelector( '#gform_wrapper_4' ).getBoundingClientRect().top - 15 );

      }

    }
  }
} );
